import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useSupplierGroupSettings = (supplierGroupId: string) => {
    return useQuery(queries.supplierGroups.detail(supplierGroupId)._ctx.settings);
};
